import React from 'react';

import GlobalStyle from 'styles/GlobalStyle';
import Routes from 'routes';

export const App = () => (
  <>
    <Routes />
    <GlobalStyle />
  </>
);

export default App;
